var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.socialMedias),function(socialMedia){return _c('v-btn',{key:socialMedia.id,attrs:{"flat":"","icon":"","color":"secondary","href":`//${socialMedia.url}`,"target":"_blank","relopener":"noopener"}},[_c('v-icon',[_vm._v(_vm._s(_vm.$vuetify.icons[socialMedia.icon]))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }